<template>
    <div
        v-if="fireList && fireList.length > 0"
        class="fire-content-wrapper"
    >
        <vue-seamless-scroll
            :data="firstList" :class-option="classOption"
            class="fire-scroll-wrapper"
        >
            <div class="fire-list">
                <div
                    v-for="(item, index) in firstList" :key="index"
                    class="fire-item"
                >
                    <div class="content">{{ item.fire_content }}</div>
                    <div class="support-num">{{ formatNum(item.fire_num) }}</div>
                </div>
            </div>
        </vue-seamless-scroll>
        <vue-seamless-scroll
            v-if="secondList.length > 0"
            :data="secondList" :class-option="classOption"
            class="fire-scroll-wrapper second-line"
        >
            <div class="fire-list">
                <div
                    v-for="(item, index) in secondList" :key="index"
                    class="fire-item"
                >
                    <div class="content">{{ item.fire_content }}</div>
                    <div class="support-num">{{ formatNum(item.fire_num) }}</div>
                </div>
            </div>
        </vue-seamless-scroll>
    </div>
</template>
<script>
import {ref} from '@vue/composition-api';
import {formatNum} from '@/utils/utility';

export default {
    props: {
        fireList: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const firstList = ref([]);
        const secondList = ref([]);
        const classOption =  {
            step: 0.5,
            limitMoveNum: 1,
            direction: 2,
            hoverStop: false,
            openTouch: false,
            singleWidth: 0,
        };

        function initData() {
            if (props.fireList && props.fireList.length >= 50) {
                for (let index = 0; index < 50; ++index) {
                    if (index % 2 === 0) {
                        firstList.value.push(props.fireList[index]);
                    }
                    else {
                        secondList.value.push(props.fireList[index]);
                    }
                }
            }
            else if (props.fireList && props.fireList.length > 1) {
                for (let index = 0; index < props.fireList.length; ++index) {
                    if (index % 2 === 0) {
                        firstList.value.push(props.fireList[index]);
                    }
                    else {
                        secondList.value.push(props.fireList[index]);
                    }
                }
                if (props.fireList.length % 2 === 1) {
                    firstList.value = firstList.value.concat(secondList.value);
                    secondList.value = secondList.value.concat(firstList.value);
                }
            }
            else {
                firstList.value = props.fireList;
            }
            while (firstList.value.length < 15 && firstList.value.length > 0) {
                firstList.value = firstList.value.concat(firstList.value);
            }
            while (secondList.value.length < 15 && secondList.value.length > 0) {
                secondList.value = secondList.value.concat(secondList.value);
            }
        }
        initData();
        return ({
            firstList,
            secondList,
            classOption,
            formatNum,
        });
    },
};
</script>
<style lang="scss" scoped>
.fire-content-wrapper {
    width: 100%;
    overflow: hidden;
    .fire-scroll-wrapper {
        height: 74px;
        margin: 0 auto;
        overflow: hidden;
        width: 5950px;
        .fire-list {
            height: 74px;
            display: flex;
            .fire-item {
                width: auto;
                display: flex;
                background: rgba(0,0,0,0.03);
                border-radius: 37px;
                height: 74px;
                padding: 0 20px 0 20px;
                line-height: 74px;
                font-size: 42px;
                font-weight: 400;
                margin-right: 18px;
                text-align: center;
                .content {
                    color: #141414;
                }
                .support-num {
                    position: relative;
                    margin-left: 16px;
                    color: #B2B2B2;
                }
            }
        }
        &.second-line {
            margin-top: 18px;
        }
    }
}
</style>
